const getComputedStyle = (node, x) => window.getComputedStyle(node, x);
export default getComputedStyle;
